import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export default function MechAccordion() {
  return (
    <div className="Accordian">
      <Accordion style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography>
              <h3>Mechanical</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="mech-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <h1
                    className="orange text-center"
                    style={{ color: "#f49221" }}
                  >
                    Mechanical
                  </h1>
                  <p>
                    The challenges are divided into two parts, Mechanics and
                    Design. The challenges are meant to test your innovative
                    skills as well as your basics in Mechanical and Mathematics.
                  </p>

                  <h2 className="">
                    <strong>Mechanics</strong>
                  </h2>
                  

<h3>
  <u>
    <b>Mechanics - Easy (NOVA IGV: Stability & Design Trade-offs)</b>
  </u>
</h3>

<p>
  Project MANAS is evaluating NOVA, an autonomous Intelligent Ground Vehicle
  (IGV) with four-wheel differential drive, carrying a fragile payload over a
  mission that includes a 25° uphill ramp, a rough gravel section, and a 15°
  downhill slope ending in an emergency braking zone.
</p>

<br />

<h3>
  <strong>Vehicle specs:</strong>
</h3>

<ul style={{ marginLeft: "20px" }}>
  <li>Total mass: 30 kg</li>
  <li>Wheel radius: 125 mm</li>
  <li>Wheelbase: 700 mm</li>
  <li>Initial CG: 320 mm above ground, midway between axles</li>
  <li>Midway through the mission, the payload shifts 110 mm rearward and 85 mm upward</li>
  <li>A constant 6 m/s headwind acts throughout</li>
</ul>

<br />

<h3>
  <strong>Part A calculation</strong>
</h3>

<p>
  Calculate only the normal reaction force on the front and rear axles after
  the payload shift, while NOVA is on the 25° uphill ramp. State whether this
  shift increases or decreases tip-over risk on this specific segment, and why.
</p>

<br />

<h3>
  <strong>Part B Failure assessment</strong>
</h3>

<p>
  Identify the single mission segment most susceptible to failure (wheel slip,
  motor stall, or tip-over), and justify your choice by weighing terrain, the
  payload shift, traction, and aerodynamic drag against each other not just
  listing effects, but explaining why this segment is worse than the other two.
</p>

<br />

<h3>
  <strong>Part C Dimensional design improvements, ranked</strong>
</h3>

<p>
  NOVA's wheelbase, track width, wheel radius, and CG height/position can all
  be modified. Propose four dimensional changes (not motor or gear ratio
  changes — dimensions and geometry only) that would improve NOVA's stability
  and traction across the mission.
</p>

<p>
  Then rank your four changes from most to least impactful while giving
  appropriate justifications.
</p>

<br />

<center>
  
</center>

<br />
                  
                  <h3>
  <u>
    <b>Mechanics — Medium</b>
  </u>
</h3>

<h3>
  <strong>UGV Camera Mount: Toppling Margin &amp; CoM Analysis — Tapered vs. Uniform Mount</strong>
</h3>

<p>
  Aarav and Shubhankar are building their latest UGV for Project MANAS. The
  chassis is a 500 mm × 500 mm × 500 mm cube, total mass 15 kg (excluding mount
  and camera), with its center of mass positioned such that 60% of the weight
  rests on the front axle and 40% on the rear. The chassis CoM sits 200 mm
  above the ground. The bot's wheelbase is 500 mm, and it is rated to operate
  on inclines up to 10% grade — a rating that must not be compromised by adding
  a camera mount.
</p>

<p>
  The team is deciding between two possible mount designs, both of identical
  total mass and identical height <b>L</b>, to carry a camera (mass 250 g,
  point mass at the mount's top):
</p>

<br />

<h3>
  <strong>Design A — Uniform mount</strong>
</h3>

<p>
  Constant linear density <b>λ<sub>A</sub>(y) = λ<sub>0</sub></b>, for
  <b> 0 ≤ y ≤ L</b>.
</p>

<br />

<h3>
  <strong>Design B — Tapered mount</strong>
</h3>

<p>
  Linearly tapering linear density
  <b> λ<sub>B</sub>(y) = λ<sub>0</sub>(1 − y/L)</b>, heaviest at the base
  (<b>y = 0</b>), tapering to zero at the camera end (<b>y = L</b>).
</p>

<p>
  Here <b>y</b> is measured from the base of the mount (at the chassis top) to
  the camera end, and <b>λ<sub>0</sub> = 0.4 kg/m</b> is the same base density
  constant used in both designs (note: this means Design A and Design B do not
  have the same total mass for the same length).
</p>

<br />

<h3>
  <strong>Your task:</strong>
</h3>

<ol style={{ marginLeft: "20px" }}>
  <li>
    For each design, derive the mount's total mass and its own CoM height (from
    its base) as a function of <b>L</b>. Explicitly state how you're
    normalizing the comparison (equal mass? equal λ<sub>0</sub>? or something
    else to justify your choice).
  </li>

  <br />

  <li>
    For Design B (tapered), determine the maximum permissible mount height
    <b> L</b> such that the combined system (chassis + mount + camera) remains
    stable (does not tip) on a 10% grade in the worst-case orientation, given
    the 60/40 front/rear weight bias.
  </li>

  <br />

  <li>
    Using the same total mount mass and same height <b>L</b> found above,
    recompute the combined system's tipping threshold for Design A (uniform)
    instead of Design B. Report the resulting maximum stable grade (or angle)
    for Design A, and explicitly compare it against the 10% requirement and
    against Design B's performance — stating clearly, in a sentence, which
    design wins and by how much (e.g., as a % difference in max stable grade,
    or as extra permissible <b>L</b> for equal stability margin).
  </li>
</ol>

<br />

                  <h3>
  <u>
    <b>Mechanics - hard</b>
  </u>
</h3>

<h3>
  <strong>Project MANAS - FREYJA Heavy-Lift Hexacopter Structural Failure Analysis</strong>
</h3>

<p>
  Project MANAS is testing FREYJA, a heavy-lift hexacopter designed for
  agricultural spraying. During a field test, one of the six arms suffers a
  sudden structural failure at its root due to an undetected manufacturing
  defect. The motor, propeller, and arm detach completely while the remaining
  five propulsion units continue operating normally. The flight controller is
  assumed to function correctly, but no changes may be made to the controller
  software during this analysis. Assume the remaining motors are capable of
  varying their thrust within their rated operating limits.
</p>

<br />

<h3>
  <strong>The hexacopter has the following specifications:</strong>
</h3>

<ul style={{ marginLeft: "20px" }}>
  <li>Total take-off mass: 18 kg</li>
  <li>Regular hexagonal frame with 900 mm motor-to-motor diameter</li>
  <li>Centre of gravity initially located at the geometric centre</li>
  <li>Identical motors and propellers on all six arms</li>
  <li>Maximum continuous thrust of each motor: 60 N</li>
</ul>

<br />

<h3>
  <strong>Your task-</strong>
</h3>

<ol style={{ marginLeft: "20px" }}>
  <li>
    Immediately after the arm detaches explain how the loss of one propulsion
    unit affects the force and moment equilibrium of the aircraft.
  </li>

  <br />

  <li>
    Determine whether controlled flight is theoretically possible using only
    the remaining five motors.
  </li>

  <br />

  <li>
    Following the arm failure:
    <ul style={{ marginLeft: "20px" }}>
      <li>
        Explain qualitatively how the loads acting on the remaining five arms
        and the central frame are redistributed and identify which remaining
        arm or structural region is now most susceptible to failure and justify
        your reasoning.
      </li>
    </ul>
  </li>

  <br />

  <li>
    If you were allowed to make only one mechanical design modification
    (excluding software, sensors, or electronics) to improve survivability in
    this scenario:
    <ul style={{ marginLeft: "20px" }}>
      <li>Describe the modification.</li>
      <li>Explain why it provides the greatest improvement.</li>
      <li>
        Discuss one disadvantage or trade-off introduced by your proposal.
      </li>
    </ul>
  </li>
</ol>

<br />


                  <h2 className="">
                    <strong>Design</strong>
                  </h2>
                  <h3>
  <u>
    <b>EASY</b>
  </u>
</h3>

<h3>
  <strong>UGV Camera Mount: Passive Vibration Isolation for Stable Camera Imaging</strong>
</h3>

<p>
  Based on the Medium Mechanical question with the same ugv dimensions.
</p>

<p>
  Shubhankar and Aarav are building their latest UGV for Project MANAS. The
  chassis is a 500 mm × 500 mm × 500 mm cube, total mass 15 kg, with its center
  of mass positioned such maximize% of the weight rests on the front axle and
  40% on the rear. A vertical camera mount rises from the top of the chassis,
  placing the camera as high as possible to maximize field of view for
  navigation and object detection.
</p>

<p>
  Because the mount is tall and relatively lightweight (to minimize its impact
  on toppling stability), it behaves like a flexible cantilever rather than a
  rigid post — vibration from motor operation, terrain irregularity, and the
  bot's own acceleration/braking will excite bending oscillations at the
  mount's tip, degrading the camera's image stability and any tracking or
  feature-matching algorithms relying on it.
</p>

<br />

<h3>
  <strong>Your task:</strong>
</h3>

<ul style={{ marginLeft: "20px" }}>
  <li>
    Design a <strong>passive mechanical vibration isolation/damping system</strong> for
    the camera at the top of the mount (e.g., compliant elastomer mounts, tuned
    mass dampers), without using any active or electronically-controlled
    components (no gimbal motors, no IMU-driven correction).
  </li>

  <br />

  <li>
    Identify the dominant vibration sources acting on the mount (e.g.,
    motor/drivetrain vibration transmitted through the chassis,
    terrain-induced impulses through the wheels, mount's own cantilever bending
    modes) and explain which your design targets and how.
  </li>

  <br />

  <li>
    Discuss any trade-offs your design introduces.
  </li>
</ul>

<br />
                  
                  <h3>
  <u>
    <b>MEDIUM (Option A)</b>
  </u>
</h3>

<p>
  A fixed-wing humanitarian UAV is designed by Adit to transport medical
  supplies to remote regions. During the final stages of development, the
  mission requirements change, increasing the payload capacity by 45%.
  However, the battery capacity, propulsion system (motor and propeller), and
  manufacturing budget must remain unchanged. Additionally, the maximum
  allowable increase in the aircraft's empty weight is limited to 15% to
  compensate for the heavier payload.
</p>

<p>
  Redesign the aircraft to meet the new mission requirements while minimizing
  reductions in endurance, flight efficiency, stability, and reliability.
</p>

<br />

<h3>
  <strong>Your proposed design must justify:</strong>
</h3>

<ul style={{ marginLeft: "20px" }}>
  <li>Airframe and wing modifications.</li>

  <br />

  <li>Material selection for primary structural components.</li>

  <br />

  <li>
    Structural reinforcement strategy while maintaining minimum weight.
  </li>

  <br />

  <li>
    Aerodynamic trade-offs affecting lift, drag, and stability.
  </li>

  <br />

  <li>
    The engineering compromises made to satisfy the conflicting design
    constraints.
  </li>
</ul>

<br />

<h3>
  <strong>Objective:</strong>
</h3>

<p>
  The objective is to achieve the lightest feasible aircraft capable of safely
  transporting the increased payload while maintaining acceptable mission
  performance.
</p>

<h3>
  <u>
    <b>MEDIUM (Option B)</b>
  </u>
</h3>

<p>
  A fixed-wing UAV is initially designed by Aditya for long-endurance
  surveillance over flat terrain. Midway through development, the mission
  profile changes to include operations in mountainous regions characterized by
  strong wind gusts, limited take-off areas, uneven landing surfaces, and
  rapidly changing weather conditions.
</p>

<p>
  However, due to project constraints, the propulsion system, battery capacity,
  payload, and their locations are fixed and cannot be modified. Furthermore,
  the UAV must remain hand-launchable by a single operator without any external
  launch assistance, and the wingspan and maximum take-off weight may not
  increase by more than 10% and 5%, respectively, from the original design. The
  use of ballast to correct the center of gravity is not permitted.
  Additionally, the redesigned UAV must retain at least 95% of the original
  flight endurance.
</p>

<p>
  Without changing the propulsion system or battery capacity, redesign the UAV
  to successfully operate in both environments while maintaining acceptable
  endurance, structural integrity, and flight stability.
</p>

<br />

<h3>
  <strong>Your design must also address the following:</strong>
</h3>

<ul style={{ marginLeft: "20px" }}>
  <li>
    Select suitable materials for the airframe, wings, landing gear, and
    structural reinforcements.
  </li>

  <br />

  <li>
    Justify whether the chosen materials can withstand the operational loads
    encountered in both flat and mountainous terrains.
  </li>

  <br />

  <li>
    Minimize the overall structural weight while ensuring adequate strength,
    stiffness, fatigue life, and manufacturability.
  </li>

  <br />

  <li>
    Discuss how the imposed constraints influence your design decisions and the
    trade-offs between aerodynamic efficiency, structural performance, cost,
    manufacturability, and reliability.
  </li>
</ul>

<br />

<h3>
  <strong>Objective:</strong>
</h3>

<p>
  Develop the lightest possible UAV that satisfies all operational and design
  constraints while maintaining safety, performance, and mission endurance
  across both operating environments.
</p>

<br />

<br />
                 
                  <h3>
  <u>
    <b>HARD</b>
  </u>
</h3>

<p>
  Design a recovery system for a fixed wing UAV which automatically activates
  during an engine failure/power loss without any electronics (all electronics
  may fail), pre-programmed landing sequence, parachutes or any stored energy
  springs, compressed gas) except for gravity.
</p>

<p>
  The design should work even if the fixed wing is upside down.
</p>

<p>
  The mechanism should also be reusable without any manual repairs.
</p>

<br />

<h3>
  <strong>Your task:</strong>
</h3>

<ul style={{ marginLeft: "20px" }}>
  <li>
    Design a completely mechanical recovery system satisfying the above
    constraints.
  </li>

  <br />

  <li>
    Explain the working principle of the mechanism and how it activates during
    an engine failure/power loss.
  </li>

  <br />

  <li>
    Justify how the mechanism functions without the use of electronics,
    pre-programmed landing sequence, parachutes, or any stored energy (springs,
    compressed gas), except for gravity.
  </li>

  <br />

  <li>
    Explain how the mechanism remains functional even if the fixed wing is
    upside down.
  </li>

  <br />

  <li>
    Describe how the recovery system can be reused without requiring any manual
    repairs after deployment.
  </li>
</ul>

<br />
                  <br />

                  <hr />
                  <br />
                  <h3>
                    <strong>Submission </strong>
                  </h3>
                  <p>
                    {" "}
                    Submit the design files, word docs, pictures or videos to
                    &nbsp;
                    <a href="mailto:projectmanas.mechanical@gmail.com ">
                      projectmanas.mechanical@gmail.com
                    </a>
                    .
                  </p>

                  <p>
                    <b>NOTE: </b> These questions can be either solved in a CAD
                    software (Fusion 360, Solidworks, etc.) or the idea can be
                    presented as a neat sketch explaining it in maximum details.
                    The submissions over mail need to be accompanied with the
                    following details:
                    <ol>
                      <li>Full Name</li>
                      <li>Registration Number</li>
                      <li>Branch</li>
                      <li>Contact Number</li>
                    </ol>
                  </p>

                  <p>
                    {" "}
                    For any queries, please feel free to contact (Preferably
                    Whatsapp):{" "}
                  </p>
                  <div className="contact">
                    <p>
                      <b>Aarav</b>
                      <br /> +91 9137613784
                      <br />
                    </p>
                    <p>
                      <b>Aditya</b>
                      <br /> +91 9380023351
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
    </div>  
    );
}